/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useStaticQuery, graphql } from 'gatsby';
import { useLocale } from '../hooks/locale';

function SEO({ description, lang, meta, title, image }) {
    const { locale } = useLocale();
    const { site } = useStaticQuery(
        graphql`
            query {
                site {
                    siteMetadata {
                        title
                        description
                        author
                        siteUrl
                    }
                }
            }
        `
    )

    const metaDescription = description || site.siteMetadata.description

    const url = site.siteMetadata.siteUrl
    const ogImage = `${url}${image || '/assets/img/cover.png'}`

    // add rtl support - Arabic is Right to Left Language
    // change ar with your RTL language
    const dir = locale === 'ar' ? 'rtl' : 'ltr'

    return (
        <HelmetProvider>
            <Helmet
                htmlAttributes={{
                    // fix html lang attribute
                    lang: locale,
                    dir,
                }}
                title={title}
                titleTemplate={`%s | ${site.siteMetadata.title}`}
                meta={[
                    {
                        name: `description`,
                        content: metaDescription,
                    },
                    {
                        property: `og:title`,
                        content: title,
                    },
                    {
                        property: `og:description`,
                        content: metaDescription,
                    },
                    {
                        property: `og:url `,
                        content: url,
                    },
                    {
                        property: `og:image`,
                        content: ogImage,
                    },
                    {
                        property: `og:type`,
                        content: `website`,
                    },
                    {
                        property: `og:locale`,
                        content: lang,
                    },
                    {
                        name: `twitter:card`,
                        content: `summary_large_image`,
                    },
                    {
                        name: `twitter:image:src`,
                        content: ogImage,
                    },
                    {
                        name: `twitter:creator`,
                        content: site.siteMetadata.author,
                    },
                    {
                        name: `twitter:title`,
                        content: title,
                    },
                    {
                        name: `twitter:description`,
                        content: metaDescription,
                    },
                    
                ].concat(meta)}
            />
        </HelmetProvider>
    )
}

SEO.defaultProps = {
    lang: `bg`,
    meta: [],
    description: ``,
}

SEO.propTypes = {
    description: PropTypes.string,
    lang: PropTypes.string,
    meta: PropTypes.arrayOf(PropTypes.object),
    title: PropTypes.string.isRequired,
}

export default SEO
